import { t } from "@/i18n-js/instance";

export const COMMUNITY_TYPE_OPTIONS = [
  {
    label: t("settings.community_bot.knowledge.type.course"),
    value: "course",
  },
  {
    label: t("settings.community_bot.knowledge.type.post"),
    value: "basic",
  },
];
